import { useState } from 'react';
import { Collapse, Paper } from '@mui/material';
import Icon from '@mui/material/Icon';
import PropTypes from 'prop-types';
import Tooltip from '@mui/material/Tooltip';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import MDTypography from 'components/MDTypography';
import MDBox from 'components/MDBox';
import { SideBarItem } from 'pages/assistants/builder/components/sidebar/sideBarItem';

/**
 * Draggable item component for the sidebar
 */
export function SideBarExpandableItem({ item, onDragStart }) {
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  return (
    <Paper
      elevation={1}
      onClick={handleClick}
      draggable
      sx={{
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        border: '1px solid',
        borderColor: (theme) => `${theme.palette[item.color].main}33`,
        opacity: item.disabled ? 0.5 : 1,
        transition: 'box-shadow 0.3s ease-in-out',
        borderRadius: '5px !important',
        backgroundColor: (theme) => `${theme.palette[item.color].main}11 !important`
      }}
    >
      <MDBox
        sx={{
          display: 'flex',
          p: 2,
          width: '100%',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Icon fontSize="medium" color={item.color}>
          {item.icon}
        </Icon>
        <Tooltip title={item.label}>
          <MDTypography
            ml={1}
            fontSize="0.85rem"
            sx={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '145px',
              flex: 1
            }}
          >
            {item.label}
          </MDTypography>
        </Tooltip>
        {open ? <ExpandLess /> : <ExpandMore />}
      </MDBox>
      <Collapse in={open} timeout="auto" unmountOnExit sx={{ width: '100%' }}>
        <MDBox sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
          {item.items?.map((item, idx) => (
            <SideBarItem key={idx} item={item} onDragStart={onDragStart} collapsable />
          ))}
        </MDBox>
      </Collapse>
    </Paper>
  );
}

SideBarExpandableItem.propTypes = {
  item: PropTypes.shape({
    type: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    items: PropTypes.arrayOf(PropTypes.object)
  }).isRequired,
  onDragStart: PropTypes.func.isRequired
};
